export default __webpack_public_path__ + "d44850108fe176305bc69018fba1b9f9.png";